import SET_UTM_SOURCE from "../../../actionTypes/utmSourceTypes";

export const setUtmSource = (payload) => (dispatch) => {
  dispatch({
    type: SET_UTM_SOURCE,
    payload,
  });
};
